const fetch = require('node-fetch');
import {baseApiPath} from '@/constants.js';

export default {
  getTownsGeo: async () => {
    let apiUrl = 'https://vermont-class-4-map.s3.amazonaws.com/assets/NH-Town-Boundaries.geojson';

    try {
      const response = await fetch(apiUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      //console.log(error);
    }

    return;
  },

  getAllTowns: async () => {

    let apiUrl = `${baseApiPath}/towns/`;

    try {
      const response = await fetch(apiUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      //console.log(error);
    }

    return;
  },
  getTownDetail: async (town) => {
    let apiUrl = `${baseApiPath}/towns/${town}`;

    try {
      const response = await fetch(apiUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      //console.log(error);
    }

    return;
  }
}